import React, {useEffect} from "react";
import { useLocation } from 'react-router-dom';
import { CorporateCodePost } from "../../../redux/corporateCodeService";
import { GenerateInvoiceForm } from "./GenerateInvoiceForm";
import { useAppDispatch } from "../../../redux/storeExports";
import {fetchInvoiceInfo, InvoiceInfoSelector} from '../../../redux/CorporateInvoice/CorporateInvoice'
interface PropState {
    code: CorporateCodePost
} 
const GenerateInvoice = () =>{
    const location = useLocation();
    const dispatch = useAppDispatch();
    const {invoiceInfo, loading} = InvoiceInfoSelector();

    let { code } = location.state as PropState;
    code = {...code,cost_per_employee_cents:code.cost_per_employee_cents/100}
    
    useEffect(()=>{
        dispatch(fetchInvoiceInfo(code.code));
    },[dispatch,code.code])
    
    return (
    <>
    {!loading && (
      <GenerateInvoiceForm 
        submitLabel='Generate Invoice' 
        corporateCode={code} 
        invoiceInfo={invoiceInfo}
      />
    )}
    </>
)
}

export default GenerateInvoice;